export enum UploadStatus {
    tostart = 1,
    inprogress = 2,
    success = 3,
    error = 4
}